<template>
  <!-- <result
    :isSuccess="true"
    :content="false"
    :title="email"
    :description="description">

    <template slot="action">
      <a-button size="large" type="primary">查看邮箱</a-button>
      <a-button size="large" style="margin-left: 10px" @click="goHomeHandle">返回首页</a-button>
    </template>

  </result> -->
  <div class="registerResult">
    <div class="result">
      <div class="result-status" :class="statusMap[status]">

      </div>
      <div class="result-desc">
        <p v-if="status == '1'">
          审核中请耐心等待审核结果，我们工作人员会在1-3工作日内完成审核
          <br/>
          将以短信的方式通知您申请结果
        </p>
        <p v-if="status == '2'">
          申请成功请耐心等待审核结果，我们工作人员会在1-3工作日内完成审核
          <br/>
          将以短信的方式通知您申请结果
        </p>
        <p v-if="status == '3'">
          {{ desc }}
        </p>

        <a-button v-if="status == '3'" class="btn" type="primary" @click="goUserAuthentication">重新认证</a-button>

      </div>
    </div>
  </div>
</template>

<script>
import { Result } from '@/components'

const statusMap = {
  1: 'status-process',
  2: 'status-success',
  3: 'status-error'
}
export default {
  name: 'RegisterResult',
  components: {
    Result
  },
  data () {
    return {
      statusMap,
      status: this.$route.query.status,
      desc: this.$route.query.desc
    }
  },
  computed: {
  },
  created () {
    this.status = this.$route.query.status
    this.desc = this.$route.query.desc
  },
  methods: {
    goUserAuthentication () {
      this.burry('7')
      this.$router.push({ name: 'userAuthentication' })
    }
  },
  watch: {
    '$route' () {
      this.status = this.$route.query.status
      this.desc = this.$route.query.desc
    }
  }
}
</script>

<style lang="less" scoped>
.registerResult {
  min-height: 100vh;
  .result {
    .result-status {
      margin: 234px auto 54px;

    }
    .result-desc {
      p {
        color: #666666;
        font-size: 24px;
        text-align: center;
        margin-bottom: 84px;
      }
      .btn {
        display: block;
        margin: 0 auto;
        width: 200px;
        height: 50px;
        font-size: 18px;
      }
    }
  }
}
</style>
